/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2TeamSide } from './MatchOperationV2TeamSide';
import {
    MatchOperationV2TeamSideFromJSON,
    MatchOperationV2TeamSideFromJSONTyped,
    MatchOperationV2TeamSideToJSON,
    MatchOperationV2TeamSideToJSONTyped,
} from './MatchOperationV2TeamSide';

/**
 * 
 * @export
 * @interface MatchOperationV2ActiveSuspension
 */
export interface MatchOperationV2ActiveSuspension {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2ActiveSuspension
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2ActiveSuspension
     */
    sourceEventId: string;
    /**
     * 
     * @type {MatchOperationV2TeamSide}
     * @memberof MatchOperationV2ActiveSuspension
     */
    teamSide: MatchOperationV2TeamSide;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2ActiveSuspension
     */
    participantId: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ActiveSuspension
     */
    startedAtEffectiveElapsedMs: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ActiveSuspension
     */
    durationMs: number;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationV2ActiveSuspension
     */
    expiresAtEffectiveElapsedMs: number;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationV2ActiveSuspension
     */
    status: MatchOperationV2ActiveSuspensionStatus;
}

/**
* @export
* @enum {string}
*/
export enum MatchOperationV2ActiveSuspensionStatus {
    Active = 'ACTIVE',
    Expired = 'EXPIRED',
    Voided = 'VOIDED'
}


/**
 * Check if a given object implements the MatchOperationV2ActiveSuspension interface.
 */
export function instanceOfMatchOperationV2ActiveSuspension(value: object): value is MatchOperationV2ActiveSuspension {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('sourceEventId' in value) || value['sourceEventId'] === undefined) return false;
    if (!('teamSide' in value) || value['teamSide'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('startedAtEffectiveElapsedMs' in value) || value['startedAtEffectiveElapsedMs'] === undefined) return false;
    if (!('durationMs' in value) || value['durationMs'] === undefined) return false;
    if (!('expiresAtEffectiveElapsedMs' in value) || value['expiresAtEffectiveElapsedMs'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MatchOperationV2ActiveSuspensionFromJSON(json: any): MatchOperationV2ActiveSuspension {
    return MatchOperationV2ActiveSuspensionFromJSONTyped(json, false);
}

export function MatchOperationV2ActiveSuspensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2ActiveSuspension {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sourceEventId': json['sourceEventId'],
        'teamSide': MatchOperationV2TeamSideFromJSON(json['teamSide']),
        'participantId': json['participantId'],
        'startedAtEffectiveElapsedMs': json['startedAtEffectiveElapsedMs'],
        'durationMs': json['durationMs'],
        'expiresAtEffectiveElapsedMs': json['expiresAtEffectiveElapsedMs'],
        'status': json['status'],
    };
}

export function MatchOperationV2ActiveSuspensionToJSON(json: any): MatchOperationV2ActiveSuspension {
    return MatchOperationV2ActiveSuspensionToJSONTyped(json, false);
}

export function MatchOperationV2ActiveSuspensionToJSONTyped(value?: MatchOperationV2ActiveSuspension | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'sourceEventId': value['sourceEventId'],
        'teamSide': MatchOperationV2TeamSideToJSON(value['teamSide']),
        'participantId': value['participantId'],
        'startedAtEffectiveElapsedMs': value['startedAtEffectiveElapsedMs'],
        'durationMs': value['durationMs'],
        'expiresAtEffectiveElapsedMs': value['expiresAtEffectiveElapsedMs'],
        'status': value['status'],
    };
}

